import { ActionIcons, ModeIcons } from 'src/app/shared/utility/constants';
import { RpeFormScope } from './rpe.model';
import { SPE_OPERATIONAL_ICON_ACTION_MAP } from './rpe-action.constants';
import { ApplyRpeActionPermissionsOptions } from './rpe-action.util';
export const RPE_INVALID_TAB_AND_LEGEND_ID = -1;

export function rpeTabFormScope(tabId: number): RpeFormScope {
  return { tabId, legendId: RPE_INVALID_TAB_AND_LEGEND_ID };
}

export function canApplyRpeFieldPermissions(pageMode: string): boolean {
  return pageMode === ModeIcons.edit || pageMode === ModeIcons.bulkEdit;
}

/** Hide unmapped toolbar icons and map catalog action identityNames (SPE modules). */
export function getSpeOperationalActionPermissionOptions(
  iconActionOverrides: Record<string, string> = {}
): ApplyRpeActionPermissionsOptions {
  return {
    iconActionOverrides: {
      ...SPE_OPERATIONAL_ICON_ACTION_MAP,
      ...iconActionOverrides,
    },
    hideUnmapped: true,
  };
}

/** Summary edit/delete/view icon → API action based on grid selection count. */
export function getRpeSummaryEditDeleteActionMap(
  uniqueSelectedCount: number,
  extraActionMap: Record<string, string> = {}
): Record<string, string> {
  const isBulk = uniqueSelectedCount > 1;
  return {
    [ActionIcons.edit]: isBulk ? ActionIcons.bulkedit : ActionIcons.edit,
    [ActionIcons.delete]: isBulk ? ActionIcons.bulkdelete : ActionIcons.delete,
    [ActionIcons.view]: resolveRpeSummaryViewActionName(uniqueSelectedCount),
    ...extraActionMap,
  };
}

/**
 * View toolbar: exactly one row → `view`; none or multi → `bulk view`
 * (no selection still opens bulk-view of the page/list).
 */
export function resolveRpeSummaryViewActionName(
  uniqueSelectedCount: number
): string {
  return uniqueSelectedCount === 1 ? 'view' : 'bulk view';
}

/** Info page edit icon in bulk-view context uses bulk edit permission. */
export function getRpeInfoEditActionMap(
  isBulkEditView: boolean,
  extraActionMap: Record<string, string> = {}
): Record<string, string> {
  return {
    [ActionIcons.edit]: isBulkEditView ? ActionIcons.bulkedit : ActionIcons.edit,
    ...extraActionMap,
  };
}
